import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import './design/tokens.css';
import './i18n';

async function bootstrap(): Promise<void> {
  // O dublê so sobe quando pedido, e o import e dinamico para que o MSW e os
  // handlers nao entrem no bundle de producao.
  if (import.meta.env.VITE_USE_MOCK === 'true') {
    const { startMockWorker } = await import('./test/msw/browser');
    await startMockWorker();
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('elemento #root ausente no index.html');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
